export default "<div class=\"wrapper\">\r\n    <ng-content></ng-content>\r\n</div>\r\n"